import { Navigate } from 'react-router';
import { RegisterWebAuthnForm } from '#components/patterns/webauthn/register/RegisterWebAuthnForm.tsx';
import { page, Titled } from '#util/title.ts';
import { isWebAuthnSupported } from '#util/webauthn-support.ts';
import { RegisterMFALayout } from '../RegisterMFALayout.tsx';
import { useMFAEnrollmentRedirect } from '../useMFAEnrollmentRedirect.ts';

/**
 * First-time passkey enrollment step. Reached from the {@link RegisterMFA}
 * choice screen; guards against direct navigation in browsers without WebAuthn.
 */
export function RegisterWebAuthnPage() {
  const onEnrolled = useMFAEnrollmentRedirect();

  if (!isWebAuthnSupported()) {
    return <Navigate to="../totp" replace={true} />;
  }

  return (
    <Titled title={() => page('Register a passkey')}>
      <RegisterMFALayout>
        <h1 className="h2 mb-16">Register a passkey</h1>
        <RegisterWebAuthnForm onSuccess={onEnrolled} />
      </RegisterMFALayout>
    </Titled>
  );
}
